<template>
  <div>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 9C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H12C12.5523 11 13 10.5523 13 10C13 9.44772 12.5523 9 12 9H7Z"
        fill="currentColor"
      />
      <path
        d="M6 14C6 13.4477 6.44772 13 7 13H10C10.5523 13 11 13.4477 11 14C11 14.5523 10.5523 15 10 15H7C6.44772 15 6 14.5523 6 14Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.95 4H16C17.6569 4 19 5.34315 19 7V11C19 11.5523 18.5523 12 18 12C15.7909 12 14 13.7909 14 16C14 18.2091 15.7909 20 18 20C18.5523 20 19 20.4477 19 21C19 21.5523 18.5523 22 18 22C17.8806 22 17.7621 21.9965 17.6445 21.9896C17.5973 21.9965 17.5491 22 17.5 22H6C4.34315 22 3 20.6569 3 19V7C3 5.34315 4.34315 4 6 4H6.05001C6.28164 2.85888 7.29052 2 8.5 2H13.5C14.7095 2 15.7184 2.85888 15.95 4ZM6.49982 6H6C5.44772 6 5 6.44772 5 7V19C5 19.5523 5.44772 20 6 20H13.5278C12.5777 18.9385 12 17.5367 12 16C12 13.027 14.1623 10.559 17 10.083V7C17 6.44772 16.5523 6 16 6H15.5002C15.0441 6.60722 14.3179 7 13.5 7H8.5C7.68209 7 6.95592 6.60722 6.49982 6ZM8 4.5C8 4.22386 8.22386 4 8.5 4H13.5C13.7761 4 14 4.22386 14 4.5C14 4.77614 13.7761 5 13.5 5H8.5C8.22386 5 8 4.77614 8 4.5Z"
        fill="currentColor"
      />
      <path
        d="M17.5393 13.2695C17.9428 12.8923 18.5756 12.9137 18.9527 13.3171L20.7305 15.2188C21.077 15.5895 21.091 16.161 20.763 16.5481L18.9852 18.6464C18.6282 19.0678 17.9972 19.12 17.5758 18.763C17.1544 18.4059 17.1022 17.7749 17.4592 17.3536L17.8421 16.9017H16C15.4477 16.9017 15 16.454 15 15.9017C15 15.3494 15.4477 14.9017 16 14.9017H17.6963L17.4917 14.6829C17.1146 14.2795 17.1359 13.6466 17.5393 13.2695Z"
        fill="currentColor"
      />
    </svg>
  </div>
</template>

<script>
import { Vue } from "vue-class-component";

export default class TransferPickup extends Vue {}
</script>
